import styled from 'styled-components'
type CheckBoxProps = {
  active?:boolean,
  disabled?:boolean,
}
type ContainerProps = {
  customStyles?:any,
  $disabled?:boolean,
}
export const Container = styled.label.withConfig({
  shouldForwardProp: (prop) => prop !== 'customStyles',
})<ContainerProps>`
  display: flex;
  align-items: center;
  min-width: 0;
  ${({customStyles}) => customStyles}

  > div {
    min-width: 0;
  }
  &:hover{
    cursor: ${({$disabled}) => $disabled ? 'not-allowed' : 'pointer'};
  }
`

export const StyledCheckBox = styled.input<CheckBoxProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  appearance:none;
  min-width: 16px;
  max-width: 16px;
  min-height:16px;
  max-height:16px;
  flex: 0 0 16px;
  border-radius: 4px;
  margin: 0px 10px 0px 0px;
  border:${({theme}) => `1px solid ${theme.grey[400]}`};
  &:checked{
    background-color: ${({theme}) => theme.accent[100]};
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M3.5 8L6.5 11L12.5 5' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};

  }
  &:indeterminate{
    background-color: ${({theme}) => theme.accent[100]};
    background-image: linear-gradient(#FFFFFF, #FFFFFF);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 8px 2px;
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
  }
  &:disabled{
    background-color: ${({theme}) => `${theme.grey[200]}`};
    border-color: ${({theme}) => `${theme.grey[400]}`};
  }
  &:hover{
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
  }
  &:focus-visible{
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`



export const CheckBoxImg = styled.img`
  margin-right: 10px;
  min-width:16px;
  max-width:16px;
  height: 16px;
  &:hover{
    cursor: pointer;
  }
`
